import { DEFAULT_BASKET_COUNT } from './basket';

export type WinnerRange = { start: number; end: number };

/** rank: 순위를 다투는 기존 모드, basket: 아래 팀 칸들에 고르게 나눠담는 모드 */
export type GameMode = 'rank' | 'basket';

class Options {
  useSkills: boolean = true;
  /** 0-based, 양끝 포함. 1명 추첨은 start === end */
  winnerRange: WinnerRange = { start: 0, end: 0 };
  autoRecording: boolean = true;

  /**
   * 팀 나누기가 기본값이다. index.html 의 loadBasketSetting 과 같은 값이어야 한다.
   * 다르면 첫 프레임에 순위 맵을 세운 뒤 팀 맵으로 다시 세우게 된다
   */
  mode: GameMode = 'basket';
  basketCount: number = DEFAULT_BASKET_COUNT;
  /** 빈 칸은 기본 이름(A, B, C…)으로 대체된다 */
  basketNames: string[] = [];
}

const options = new Options();
export default options;
